module.exports = __webpack_public_path__ + "img/utility_driving.2847d75c.svg";